export const page = 15;
export const card = 20;
export const cardRadius = 15;
